import React from "react";
import { ClipLoader } from "react-spinners";

const Loader = ({ size = 50, color = "#a100ff" ,loadingtxt}) => {
  return (
    <div style={overlayStyle}>
      <div style={loaderContainer}>
        <ClipLoader size={size} color={color} className="loadingIcon"/>
        { loadingtxt?
        <p className="loadingtxt">{loadingtxt}</p> :
        <p className="loadingtxt">Loading your portfolio data, Please hold on a moment</p> }
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.7)", // lighter transparent white
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999, // very high to cover everything
};

const loaderContainer = {
  display: "block",
  justifyContent: "center",
  alignItems: "center",
};

export default Loader;
